angular.module('edxResources')
  .factory('edxResourcesContentService', [
    '$log',
    'configuration',
    'edxFeatureFlagService',
    'edxResourcesContent',
    'moment',
    function ($log, configuration, edxFeatureFlagService, edxResourcesContent, moment) {
      var pdOnBoardingEnabled = edxFeatureFlagService.isPdOnBoardingEnabled();

      var assetsRoot = configuration.getConstant('dreambox_static_content_url');
      var dashboardAssetsRoot = assetsRoot + '/dashboard';

      var curDate = moment();

      function parseTabData (role, tabData) {
        return _.assign(
          {},
          tabData,
          {'modules': parseModules(role, tabData.modules)});
      }

      function parseModules (role, modules) {
        return _.map(modules, parseModule.bind(null, role));
      }

      function parseModule (role, module) {
        return _.assign(
          {},
          module,
          {
            'resources': parseResources(
              filterResourcesOnPdFeatureFlag(
                filterResourcesOnRole(role, module.resources)))
          });
      }

      function filterResourcesOnRole (role, resources) {
        return _.filter(resources, function (resource) {
          // If the resource is not filtered on any roles, include it.
          if (!resource.roles) {
            return true;
          }

          return role && resource.roles.indexOf(role) !== -1;
        });
      }

      function filterResourcesOnPdFeatureFlag (resources) {
        if (pdOnBoardingEnabled) {
          return resources;
        }

        return _.filter(resources, function (resource) {
          return !resource.pdOnBoarding;
        });
      }

      function parseResources (resources) {
        return _.map(resources, parseResource);
      }

      function parseResource (resource) {
        var isNew = false;

        if (resource.newUntil) {
          var newDate = moment(resource.newUntil);

          if (newDate.isValid()) {
            isNew = curDate.isBefore(newDate);
          }
          else {
            $log.warn('resource with name = ' + resource.name + '. Failed to read \'new until\' date: ' + resource.newUntil +
              '. \'New\' badge will not display');
          }
        }

        return _.assign(
          {},
          resource,
          {
            'image': resource.image ? parseUrl(resource.image) : null,
            'links': resource.links ? _.map(resource.links, parseLink) : null,
            'new': isNew
          });
      }

      function parseLink (link) {
        return _.assign(
          {},
          link,
          {
            'url': parseUrl(link.url)
          });
      }

      function parseUrl (url) {
        switch(url.base) {
          case 'local':
            return '/resources' + url.path;
          case 'static_content':
            return assetsRoot + url.path;
          case 'dashboard':
            return dashboardAssetsRoot + url.path;
          case 'external':
            return url.path;
          case 'edex':
            return url.path;
          default:
            return url.path;
        }
      }

      var tabDataSections = ['classroomTabData', 'parentsTabData', 'dashboardTabData', 'motivatorsTabData'];

      return {
        getResources: function (role) {
          var resources = {};

          _.forEach(tabDataSections, function(key) {
            resources[key] = parseTabData(role, edxResourcesContent[key]);
          });

          resources.startHereModules = parseModules(role, edxResourcesContent.startHereModules);

          return resources;
        }
      };
    }
  ]);
